import React, { useState, useEffect } from "react";
import qs from 'query-string'

import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field } from "formik";
import usePlans from "../../hooks/usePlans";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import InputMask from 'react-input-mask';
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	FormHelperText,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Select,
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import logo from "../../assets/logo.png";
import { i18n } from "../../translate/i18n";

import { openApi } from "../../services/api";
import toastError from "../../errors/toastError";
import { CNPJ_MASK, isValidCnpj, onlyDigits } from "../../utils/cnpj";
import termsEnabled from "../Terms/termsEnabled";
import { TERMS_VERSION } from "../Terms/termsText";
const Copyright = () => {
	return (
		<Typography variant="body2" color="textSecondary" align="center">
			{"Copyright © "}
			<Link color="inherit" href="#">
				PLW
			</Link>{" "}
		   {new Date().getFullYear()}
			{"."}
		</Typography>
	);
};

const useStyles = makeStyles(theme => ({
	paper: {
		marginTop: theme.spacing(8),
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: "100%",
		marginTop: theme.spacing(3),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
}));

const UserSchema = Yup.object().shape({
	name: Yup.string()
		.min(2, () => i18n.t("validation.tooShort"))
		.max(50, () => i18n.t("validation.tooLong"))
		.required(() => i18n.t("validation.required")),
	cnpj: Yup.string()
		.required(() => i18n.t("settings.companiesManager.validation.cnpjRequired"))
		.test("valid-cnpj", () => i18n.t("validation.invalidCnpj"), (value) => isValidCnpj(value)),
	password: Yup.string()
		.min(5, () => i18n.t("validation.tooShort"))
		.max(50, () => i18n.t("validation.tooLong"))
		.required(() => i18n.t("validation.required")),
	email: Yup.string()
		.email(() => i18n.t("validation.invalidEmail"))
		.required(() => i18n.t("validation.required")),
	planId: Yup.string().required(() => i18n.t("signup.validation.planRequired")),
	// Aceite só onde os Termos estão ligados (REACT_APP_SHOW_TERMS).
	// Mensagem como função: o schema é criado antes do idioma ser carregado.
	...(termsEnabled && {
		acceptedTerms: Yup.boolean().oneOf([true], () => i18n.t("signup.form.acceptTermsRequired")),
	}),
});

const SignUp = () => {
	const classes = useStyles();
	const history = useHistory();
	let companyId = null

	const params = qs.parse(window.location.search)
	if (params.companyId !== undefined) {
		companyId = params.companyId
	}

	const initialState = { name: "", cnpj: "", email: "", phone: "", password: "", planId: "", acceptedTerms: false };

	const [user] = useState(initialState);
	// dueDate/status/recurrence são definidos pelo BACKEND no cadastro público
	// (trial de 1 mês grátis do plano escolhido) — não enviar do cliente
	const handleSignUp = async values => {
		// envia apenas os dígitos do CNPJ (sem máscara)
		const payload = {
			...values,
			campaignsEnabled: true,
			cnpj: onlyDigits(values.cnpj),
		};
		// Aceite dos Termos: o backend grava a data (do servidor) e a versão.
		// Site com os Termos desligados não manda nada.
		delete payload.acceptedTerms;
		if (termsEnabled && values.acceptedTerms === true) {
			payload.acceptedTerms = true;
			payload.termsVersion = TERMS_VERSION;
		}
		try {
			await openApi.post("/companies/cadastro", payload);
			toast.success(i18n.t("signup.toasts.success"));
			history.push("/login");
		} catch (err) {
			console.log(err);
			toastError(err);
		}
	};

	const [plans, setPlans] = useState([]);
	const [showPassword, setShowPassword] = useState(false);
	const { list: listPlans } = usePlans();

	useEffect(() => {
		async function fetchData() {
			try {
				const list = await listPlans();
				// defesa extra: plano sem valor de cobrança nunca aparece no cadastro
				setPlans(
					(Array.isArray(list) ? list : []).filter(
						(plan) => Number(plan.value) > 0
					)
				);
			} catch (err) {
				// sem esse aviso a lista de planos ficava vazia em silêncio e,
				// como planId é obrigatório, o cadastro travava sem explicação
				toastError(err);
			}
		}
		fetchData();
	}, []);


	return (
		<Container component="main" maxWidth="xs">
			<CssBaseline />
			<div className={classes.paper}>
				<div>
					<center><img style={{ margin: "0 auto", width: "70%" }} src={logo} alt="Whats" /></center>
				</div>
				{/*<Typography component="h1" variant="h5">
					{i18n.t("signup.title")}
				</Typography>*/}
				{/* <form className={classes.form} noValidate onSubmit={handleSignUp}> */}
				<Formik
					initialValues={user}
					enableReinitialize={true}
					validationSchema={UserSchema}
					onSubmit={async (values, actions) => {
						// precisa aguardar o POST: antes o setSubmitting(false)
						// rodava antes da resposta e o botão continuava ativo,
						// então um duplo clique disparava dois cadastros — o
						// segundo voltava como "empresa já cadastrada"
						try {
							await handleSignUp(values);
						} finally {
							actions.setSubmitting(false);
						}
					}}
				>
					{({ touched, errors, isSubmitting }) => (
						<Form className={classes.form}>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<Field
										as={TextField}
										autoComplete="name"
										name="name"
										error={touched.name && Boolean(errors.name)}
										helperText={touched.name && errors.name}
										variant="outlined"
										fullWidth
										id="name"
										label={i18n.t("companies.form.name")}
									/>
								</Grid>

								<Grid item xs={12}>
									<Field name="cnpj">
										{({ field }) => (
											<InputMask
												{...field}
												mask={CNPJ_MASK}
												maskChar={null}
											>
												{(inputProps) => (
													<TextField
														{...inputProps}
														variant="outlined"
														fullWidth
														label="CNPJ"
														placeholder="00.000.000/0000-00"
														error={touched.cnpj && Boolean(errors.cnpj)}
														helperText={touched.cnpj && errors.cnpj}
													/>
												)}
											</InputMask>
										)}
									</Field>
								</Grid>

								<Grid item xs={12}>
									<Field
										as={TextField}
										variant="outlined"
										fullWidth
										id="email"
										label={i18n.t("signup.form.email")}
										name="email"
										error={touched.email && Boolean(errors.email)}
										helperText={touched.email && errors.email}
										autoComplete="email"
										required
									/>
								</Grid>
								
							<Grid item xs={12}>
								<Field name="phone">
									{({ field }) => (
										<InputMask
											{...field}
											mask="(99) 99999-9999"
											maskChar={null}
										>
											{(inputProps) => (
												<TextField
													{...inputProps}
													variant="outlined"
													fullWidth
													label={i18n.t("signup.form.phone")}
													error={touched.phone && Boolean(errors.phone)}
													helperText={touched.phone && errors.phone}
												/>
											)}
										</InputMask>
									)}
								</Field>
							</Grid>
								<Grid item xs={12}>
									<Field
										as={TextField}
										variant="outlined"
										fullWidth
										name="password"
										error={touched.password && Boolean(errors.password)}
										helperText={touched.password && errors.password}
										label={i18n.t("signup.form.password")}
										type={showPassword ? "text" : "password"}
										id="password"
										autoComplete="current-password"
										required
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label={i18n.t("login.form.showHidePassword")}
														onClick={() => setShowPassword(prev => !prev)}
														onMouseDown={e => e.preventDefault()}
														edge="end"
													>
														{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											),
										}}
									/>
								</Grid>
								<Grid item xs={12}>
									<InputLabel htmlFor="plan-selection">{i18n.t("companies.form.plan")}</InputLabel>
									<Field
										as={Select}
										variant="outlined"
										fullWidth
										id="plan-selection"
										label={i18n.t("companies.form.plan")}
										name="planId"
										required
									>
										{plans.map((plan, key) => (
											<MenuItem key={key} value={plan.id}>
												{i18n.t("signup.form.planOption", {
													name: plan.name,
													users: plan.users,
													connections: plan.connections,
													queues: plan.queues,
													value: plan.value,
												})}
											</MenuItem>
										))}
									</Field>
									<Typography variant="caption" color="textSecondary">
										{i18n.t("signup.form.freeTrial")}
									</Typography>
								</Grid>
								{termsEnabled && (
								<Grid item xs={12}>
									<FormControlLabel
										control={
											<Field
												as={Checkbox}
												type="checkbox"
												name="acceptedTerms"
												color="primary"
											/>
										}
										label={
											<Typography variant="body2">
												{i18n.t("signup.form.acceptTermsPrefix")}{" "}
												{/* Nova aba: o formulário preenchido não se perde */}
												<Link href="/termos" target="_blank" rel="noopener noreferrer">
													{i18n.t("signup.form.acceptTermsLink")}
												</Link>
											</Typography>
										}
									/>
									{touched.acceptedTerms && errors.acceptedTerms && (
										<FormHelperText error>{errors.acceptedTerms}</FormHelperText>
									)}
								</Grid>
								)}
							</Grid>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
								disabled={isSubmitting}
							>
								{i18n.t("signup.buttons.submit")}
							</Button>
							<Grid container justify="flex-end">
								<Grid item>
									<Link
										href="#"
										variant="body2"
										component={RouterLink}
										to="/login"
									>
										{i18n.t("signup.buttons.login")}
									</Link>
								</Grid>
							</Grid>
						</Form>
					)}
				</Formik>
			</div>
			<Box mt={5}>{/* <Copyright /> */}</Box>
		</Container>
	);
};

export default SignUp;
